import { useEffect, useMemo, useState } from 'react'
import UzytkownicyService from '@/services/UzytkownicyService'

function formatUzytkownikLabel(item) {
	const name = `${item?.nazwa || item?.name || ''}`.trim() || '-'
	const email = `${item?.email || ''}`.trim()
	return email ? `${name} (${email})` : name
}

export default function useUzytkownikFilterModal(isOpen, selectedUzytkownikId) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedUzytkownikId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedUzytkownikId || '')
	}, [isOpen, selectedUzytkownikId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const options = { limit: 200, sortColumn: 'nazwa', sortDirection: 'asc' }
			const result = query
				? await UzytkownicyService.search(query, options)
				: await UzytkownicyService.getAll(options)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected ? formatUzytkownikLabel(selected) : ''
	}, [items, activeId])

	return {
		searchTerm,
		setSearchTerm,
		items,
		loading,
		error,
		activeId,
		setActiveId,
		selectedName,
		labelAccessor: formatUzytkownikLabel,
		clearFilter: () => setActiveId(''),
	}
}
